import React from 'react';
import { Neighborhood } from 'types/app';
import { Link } from '../../../../components/Link';
import { buildCols } from '../../../../utils';
import { ColumnList } from '../../../../wag-react/components/ColumnList';
import { Box } from '../../../../wag-react/next-components/box';
type Props = {
  neighborhoods: Neighborhood[];
};
export const NeighborhoodList = ({
  neighborhoods
}: Props) => {
  const createNeighborhoodObjs = () => {
    const neighborhoodObjs = neighborhoods.map(neighborhood => <Box key={neighborhood.name} py="4px">
        <Link href={`${neighborhood.url}`} color="medGray">
          {neighborhood.name}
        </Link>
      </Box>);
    return neighborhoodObjs;
  };
  const NUM_COLS_DESKTOP = 4;
  const NUM_COLS_MOBILE = 1;
  const neighborhoodObjs = createNeighborhoodObjs();
  const desktopCols = buildCols(NUM_COLS_DESKTOP, neighborhoodObjs);
  const mobileCols = buildCols(NUM_COLS_MOBILE, neighborhoodObjs);
  return <>
      <ColumnList display={['flex', null, 'none']} cols={mobileCols} data-sentry-element="ColumnList" data-sentry-source-file="NeighborhoodList.tsx" />
      <ColumnList display={['none', null, 'flex']} cols={desktopCols} data-sentry-element="ColumnList" data-sentry-source-file="NeighborhoodList.tsx" />
    </>;
};